import {Parser, ParseResult} from "./parser";
import {BlockMarkupItemType} from "../markup.interface";

const marker = '{code}';

export const codeParser: Parser = {
    matches(markup: string, startIndex: number): boolean {
        return markup.substring(startIndex, startIndex + marker.length) === marker
            && markup.indexOf(marker, startIndex + marker.length) !== -1;
    },

    parse(markup: string, startIndex: number): ParseResult {
        const enclosureMarkerIndex = markup.indexOf(marker, startIndex + marker.length);

        return {
            item: {
                type: BlockMarkupItemType.Code,
                code: markup.substring(startIndex + marker.length, enclosureMarkerIndex).trim(),
            },
            lastIndex: enclosureMarkerIndex + marker.length,
        };
    }
}
